import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { useLayoutEffect as $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c } from "./useLayoutEffect.module.js";
import { flushSync as $jJMAe$flushSync } from "react-dom";
import { useState as $jJMAe$useState, useCallback as $jJMAe$useCallback } from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $d3f049242431219c$export$6d3443f2c48bfc20(ref) {
  var isReady = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var _ref = (0, $jJMAe$useState)(true),
    _ref2 = _slicedToArray(_ref, 2),
    isEntering = _ref2[0],
    setEntering = _ref2[1];
  var isAnimationReady = isEntering && isReady;
  // There are two cases for entry animations:
  // 1. CSS @keyframes. The `animation` property is set during the isEntering state, and it is removed after the animation finishes.
  // 2. CSS transitions. The initial styles are applied during the isEntering state, and removed immediately, causing the transition to occur.
  //
  // In the second case, cancel any transitions that were triggered prior to the isEntering = false state (when the transition is supposed to start).
  // This can happen when isReady starts as false (e.g. popovers prior to placement calculation).
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(function () {
    if (isAnimationReady && ref.current && 'getAnimations' in ref.current) {
      var _iterator = _createForOfIteratorHelper(ref.current.getAnimations()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var animation = _step.value;
          if (animation instanceof CSSTransition) animation.cancel();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, [ref, isAnimationReady]);
  $d3f049242431219c$var$useAnimation(ref, isAnimationReady, (0, $jJMAe$useCallback)(function () {
    return setEntering(false);
  }, []));
  return isAnimationReady;
}
function $d3f049242431219c$export$45fda7c47f93fd48(ref, isOpen) {
  var _ref3 = (0, $jJMAe$useState)(isOpen ? 'open' : 'closed'),
    _ref4 = _slicedToArray(_ref3, 2),
    exitState = _ref4[0],
    setExitState = _ref4[1];
  switch (exitState) {
    case 'open':
      // If isOpen becomes false, set the state to exiting.
      if (!isOpen) setExitState('exiting');
      break;
    case 'closed':
    case 'exiting':
      // If we are exiting and isOpen becomes true, the animation was interrupted.
      // Reset the state to open.
      if (isOpen) setExitState('open');
      break;
  }
  var isExiting = exitState === 'exiting';
  $d3f049242431219c$var$useAnimation(ref, isExiting, (0, $jJMAe$useCallback)(function () {
    // Set the state to closed, which will cause the element to be unmounted.
    setExitState(function (state) {
      return state === 'exiting' ? 'closed' : state;
    });
  }, []));
  return isExiting;
}
function $d3f049242431219c$var$useAnimation(ref, isActive, onEnd) {
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(function () {
    if (isActive && ref.current) {
      if (!('getAnimations' in ref.current)) {
        // JSDOM
        onEnd();
        return;
      }
      var animations = ref.current.getAnimations();
      if (animations.length === 0) {
        onEnd();
        return;
      }
      var canceled = false;
      Promise.all(animations.map(function (a) {
        return a.finished;
      })).then(function () {
        if (!canceled) (0, $jJMAe$flushSync)(function () {
          onEnd();
        });
      }).catch(function () {});
      return function () {
        canceled = true;
      };
    }
  }, [ref, isActive, onEnd]);
}
export { $d3f049242431219c$export$6d3443f2c48bfc20 as useEnterAnimation, $d3f049242431219c$export$45fda7c47f93fd48 as useExitAnimation };